export default [
  {
    perfil: 'Administrador',
    roles: [
      {
        rol: 'Administración',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Planeación',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Presupuesto',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Programación',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Licitaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Adjudicaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
    ],
  },

  {
    perfil: 'Planeación',
    roles: [
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Planeación',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Presupuesto',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Programación',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Licitaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Adjudicaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

  {
    perfil: 'Contratos',
    roles: [
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Planeación',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Presupuesto',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Programación',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Licitaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Adjudicaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

  {
    perfil: 'Supervisión',
    roles: [
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Planeación',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Presupuesto',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Programación',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Licitaciones',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Adjudicaciones',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

  {
    perfil: 'Estimaciones',
    roles: [
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Planeación',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Presupuesto',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Programación',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Licitaciones',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Adjudicaciones',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: false,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: true,
          crear: true,
          editar: true,
          eliminar: true,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },
  {
    perfil: 'Consultas',
    roles: [
      {
        rol: 'Configuración',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Planeación',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Presupuesto',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Programación',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Licitaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Adjudicaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Contratos',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Supervisión',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Estimaciones',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'Consultas',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
      {
        rol: 'TableroExpedientes',
        scopes: {
          ver: true,
          crear: false,
          editar: false,
          eliminar: false,
        },
      },
    ],
  },

];
